import { render, staticRenderFns } from "./InformationInDashboard.vue?vue&type=template&id=41a52a65"
import script from "./InformationInDashboard.vue?vue&type=script&lang=js"
export * from "./InformationInDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a52a65')) {
      api.createRecord('41a52a65', component.options)
    } else {
      api.reload('41a52a65', component.options)
    }
    module.hot.accept("./InformationInDashboard.vue?vue&type=template&id=41a52a65", function () {
      api.rerender('41a52a65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/dashboard_content/InformationInDashboard.vue"
export default component.exports